import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route, withRouter } from 'react-router'
import _ from 'lodash'
import cx from 'classnames'
import log from 'loglevel'

import config from '../../../../config'

import ToggleButton from './components/ToggleButton'

import hocConnect from './hocConnect'

import './style.scss'

// dynamically get Ribbon components
const ribbonModules = _.map(
    _.filter(config.modules, (module) => module.ribbon),
    (module) => module.key
)
const ribbonComponents = _.reduce(
    ribbonModules,
    (acc, module) => {
        let component = null
        try {
            // eslint-disable-next-line import/no-dynamic-require, global-require
            component = require(`../../scenes/${_.upperFirst(module)}/components/Ribbon`).default
        } catch (error) {
            log.warn(`Missing Ribbon component ${module}`)
        }

        return {
            ...acc,
            [module]: component,
        }
    },
    {}
)

@withRouter
@hocConnect
export default class Ribbon extends Component {
    static propTypes = {
        open: PropTypes.bool.isRequired,
        show: PropTypes.bool,
    }

    static defaultProps = {
        show: true,
    }

    render() {
        const { open, show } = this.props

        const routes = _.map(ribbonComponents, (RibbonComponent, module) => {
            if (RibbonComponent === null) return null

            return <Route key={module} path={`/${config.modules[module].route}`} component={RibbonComponent} />
        })

        return (
            <div className={cx('ribbon', (!open || !show) && 'hide')}>
                <div className={'wrap'}>{routes}</div>
                <div className={'shadow'} />
                <ToggleButton show={show} />
            </div>
        )
    }
}
